// The page footer. Only links with real destinations: a status page and a
// changelog join when those exist (the design sketches both).
export const LandingFooter = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '10px 24px',
      marginTop: 56,
      padding: '20px 0 10px',
      borderTop: '1px solid var(--curri-border)',
      fontSize: 13,
      color: 'var(--curri-text-tertiary)',
    }}
  >
    <span>© 2026 Curri · BUILD Developer Platform</span>
    <span style={{ flex: 1 }} />
    <a
      href="mailto:support@curri.com"
      style={{ color: 'var(--curri-text-secondary)' }}
    >
      Support
    </a>
    <a
      href="https://www.curri.com"
      style={{ color: 'var(--curri-text-secondary)' }}
    >
      curri.com
    </a>
  </div>
)
